export function downloadFile({ url }: { url: string; fileName: string }) {
  window.open(url, '_blank');
}
